// ======================================================================
// File Name       : enterpriseNotification
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { CAN_ACCESS, DISABLE, LO_SUPER_USER, SUPER_USER, WRITE, READ } from '../../constants';

export function getEnterpriseNotificationList(params, displayUserType) {
  const superUser = [LO_SUPER_USER, SUPER_USER].indexOf(displayUserType) > -1;
  if (superUser) {
    return commonCallApi({
      path: 'noticeForEnterprise/GetList',
      data: { ...params },
      enterpriseId: 1,
    });
  }
  return commonCallApi({
    path: 'noticeForEnterprise/GetList',
    data: { ...params },
  });
}
